<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListGlyphicons" [ttFilter]="setting.filtervalue" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)"></tt-list>
</tt-page>
